import { LocatorHero } from "./LocatorHero";
import { LocatorSection } from "./LocatorSection";

export const components = {
  locator_hero: LocatorHero,
  locator_section: LocatorSection
}